export enum SignalStrength {
  EXCELLENT = 4,
  GOOD = 3,
  FAIR = 2,
  POOR = 1,
}

export const SIGNAL_STRENGTH_LABELS: Record<SignalStrength, string> = {
  [SignalStrength.EXCELLENT]: 'EXCELLENT',
  [SignalStrength.GOOD]: 'GOOD',
  [SignalStrength.FAIR]: 'FAIR',
  [SignalStrength.POOR]: 'POOR',
};

export function getSignalStrengthLabel(strength: number): string {
  return (
    SIGNAL_STRENGTH_LABELS[strength as SignalStrength] ||
    SIGNAL_STRENGTH_LABELS[SignalStrength.POOR]
  );
}
